import React from 'react';
import withSizes from 'react-sizes';

import '../css/toggle.css';
import useDarkmode from '../hooks/useDarkmode';

import Darkmode from '../services/darkmode';

function Toggle(props) {

  const darkmode = useDarkmode();

  return (
    <span className={props.checked ? 'toggle toggle-checked clickable' : 'toggle clickable'} onClick={() => {
        props.onClick()
    }}>
        {props.children}
    </span>
  );
};

Toggle.defaultProps = {
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(Toggle);